import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

  constructor() { }
  
  _Math : Math;
  private _pageIndex : number = 0;
  @Input() set pageIndex(value : number){
    this._pageIndex = value;
    if(value && this.length) {
      this.lastPage = Math.trunc( this.length/this.pageSize );
    }
  }
  get pageIndex() {
    return this._pageIndex
  }
  private _length : number = 0;
  @Input() set length(value : number){
    this._length = value;
    if(value && this.length) {
      this.lastPage = Math.trunc( this.length/this.pageSize );
    }
  }
  get length() {
    return this._length
  }
  private _pageSize : number = 10;
  @Input() set pageSize(value : number){
    this._pageSize = value;
    if(value && this.length) {
      this.lastPage = Math.trunc( this.length/this.pageSize );
    }
  }
  get pageSize() {
    return this._pageSize
  }

  lastPage : number =  0;
  @Output() page : EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  ngOnInit() {
  }

  changePage( index : number){
    this.page.emit({ pageIndex : index, pageSize: this.pageSize, length : this.length});
  }

}
